module.exports = __webpack_public_path__ + "img/fax-scan.f8d7a316.svg";